<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh py-5">
            <Col :xs="24" :md="22" :lg="20">
                <Card class="shadow">
                    <Row align="middle">
                        <Col :xs="24">
                            <Steps :current="data.current">
                                <Step :title="$t('model.register.fisherman.title')"> </Step>
                                <Step :title="$t('model.register.fisherman.check')"> </Step>
                                <Step :title="$t('model.register.fisherman.checkVerify')"> </Step>
                                <Step :title="$t('model.register.fisherman.verifyIdentity')" v-if="data.useForm.modelRef?.refPersonType?.key === '2'">
                                </Step>
                                <Step :title="$t('model.register.fisherman.success')"> </Step>
                            </Steps>
                            <div v-if="data.current === 0">
                                <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                                    <TemplateBuilder
                                        :rowProp="data.rowProp"
                                        :useForm="data.useForm"
                                        :fields="data.fields"
                                        :skeleton="isLoading"
                                    ></TemplateBuilder>
                                </Form>
                                <!-- eslint-disable-next-line vue/no-mutating-props-->
                                <Tabs v-model:activeKey="data.tabKey" v-if="data.useForm.modelRef?.refPersonType?.key === '1'">
                                    <TabPane key="UserSyndicate" :tab="$t('views.request.register.company')" :forceRender="true">
                                        <UserSyndicateForm
                                            :menuContext="menuContext"
                                            :viewOnly="viewOnly"
                                            :dataProp="data"
                                            :isLoading="isLoading"
                                            itemsKey="userCorporateCommittees"
                                            canCreate="!viewOnly"
                                            canDelete="!viewOnly"
                                        ></UserSyndicateForm>
                                    </TabPane>
                                    <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                                        <AttachmentForm
                                            :menuContext="menuContext"
                                            :viewOnly="viewOnly"
                                            :dataProp="data"
                                            :isLoading="isLoading"
                                            itemsKey="attachments"
                                            canCreate="!viewOnly"
                                            canDelete="!viewOnly"
                                        ></AttachmentForm>
                                    </TabPane>
                                </Tabs>
                            </div>
                            <div v-if="data.current === 1">
                                <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                                    <TemplateBuilder
                                        :rowProp="data.rowProp"
                                        :useForm="data.useForm"
                                        :fields="data.fields"
                                        :skeleton="isLoading"
                                    ></TemplateBuilder>
                                </Form>
                                <Tabs v-model:activeKey="data.tabKey" v-if="data.useForm.modelRef?.refPersonType?.key === '1'">
                                    <TabPane key="UserSyndicate" :tab="$t('views.request.register.company')" :forceRender="true">
                                        <UserSyndicateForm
                                            :menuContext="menuContext"
                                            viewOnly="true"
                                            :dataProp="data"
                                            :isLoading="isLoading"
                                            itemsKey="userCorporateCommittees"
                                        ></UserSyndicateForm>
                                    </TabPane>
                                    <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                                        <AttachmentForm
                                            :menuContext="menuContext"
                                            viewOnly="true"
                                            :dataProp="data"
                                            :isLoading="isLoading"
                                            itemsKey="attachments"
                                        ></AttachmentForm>
                                    </TabPane>
                                </Tabs>
                                <Divider></Divider>
                                <Card>
                                    <p>{{ $t("views.register.condition") }}</p>
                                    <Checkbox v-model:checked="data.useForm.modelRef.acceptCondition" required>
                                        <span><a v-bind:href="data.pdpa" target="_blank">{{$t("views.register.pdpa")}} </a></span>
                                        <span>{{ $t("views.register.acceptCondition") }}</span>
                                    </Checkbox>
                                    <div class="has-error" v-if="data.useForm.validateInfos['acceptCondition']?.validateStatus === 'error'">
                                        <div class="ant-form-explain">
                                            {{ data.useForm.validateInfos["acceptCondition"]?.help }}
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div v-if="data.current === 2">
                                <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                                    <TemplateBuilder
                                        :rowProp="data.rowProp"
                                        :useForm="data.useForm"
                                        :fields="data.fields"
                                        :skeleton="isLoading"
                                    ></TemplateBuilder>
                                </Form>
                                <Tabs v-model:activeKey="data.tabKey" v-if="data.useForm.modelRef?.refPersonType?.key === '1'">
                                    <TabPane key="UserSyndicate" :tab="$t('views.request.register.company')" :forceRender="true">
                                        <UserSyndicateForm
                                            :menuContext="menuContext"
                                            viewOnly="true"
                                            :dataProp="data"
                                            :isLoading="isLoading"
                                            itemsKey="userCorporateCommittees"
                                        ></UserSyndicateForm>
                                    </TabPane>
                                    <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                                        <AttachmentForm
                                            :menuContext="menuContext"
                                            viewOnly="true"
                                            :dataProp="data"
                                            :isLoading="isLoading"
                                            itemsKey="attachments"
                                        ></AttachmentForm>
                                    </TabPane>
                                </Tabs>
                            </div>
                            <div v-if="data.current === 3 && data.useForm.modelRef?.refPersonType?.key === '2'">
                                <VerifyIdentityFileForm
                                    :menuContext="menuContext"
                                    :viewOnly="viewOnly"
                                    :dataProp="data"
                                    :isLoading="isLoading"
                                ></VerifyIdentityFileForm>
                            </div>
                            <div v-if="data.current === 4 || (data.current === 3 && data.useForm.modelRef?.refPersonType?.key === '1')">
                                <div class="text-center">
                                    <div><img :src="data.lastPageImg" style="width: 15%" /></div>
                                    <div v-if="(data.current === 3 && data.useForm.modelRef?.refPersonType?.key === '1')" ><h1 style="color: #ffbf00">{{ $t("model.register.wait") }}</h1></div>
                                    <div>{{ data.lastPageDetail }}</div>
                                </div>
                            </div>
                            <div class="d-flex mt-2">
                                <Button
                                    @click="() => onPrevRegister({ props, data })"
                                    :disabled="isLoading"
                                    v-if="
                                        data.current > 0 &&
                                            !(data.current === 4 || (data.current === 3 && data.useForm.modelRef?.refPersonType?.key === '1'))
                                    "
                                >
                                    <span>{{ $t("button.prev") }}</span>
                                </Button>
                                <Button
                                    class="btn-primary ml-auto"
                                    @click="() => onNextRegister({ props, data })"
                                    :disabled="isLoading"
                                    v-if="!(data.current === 4 || (data.current === 3 && data.useForm.modelRef?.refPersonType?.key === '1'))"
                                >
                                    <span>{{ $t("button.next") }}</span>
                                </Button>
                                <Button
                                    class="btn-primary ml-auto"
                                    @click="() => router.push({ name: 'login' })"
                                    :disabled="isLoading"
                                    v-if="data.current === 4 || (data.current === 3 && data.useForm.modelRef?.refPersonType?.key === '1')"
                                >
                                    <span>{{ $t("button.login") }}</span>
                                </Button>
                            </div>

                            <div class="text-center"  v-if="!(data.current === 4 || (data.current === 3 && data.useForm.modelRef?.refPersonType?.key === '1'))">
                                <router-link :to="{ name: 'login' }">{{ $t("button.login") }}</router-link>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>

import { Button, Card, Col, Form, Layout, Row, Tabs, Steps, Checkbox } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../app.logic";
import { Divider } from "ant-design-vue";
import router from "../../../router";
import { initForm, isLoading, onNextRegister, onPrevRegister, onClickOpenModalOtp, createRulesTab1 } from "./register-fisherman.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        Button,
        Layout,
        Row,
        Col,
        Steps,
        Checkbox,
        Divider,
        Step: Steps.Step,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
        UserSyndicateForm: defineAsyncComponent(() => import("./user-syndicate/UserSyndicateForm")),
        AttachmentForm: defineAsyncComponent(() => import("./attachment/AttachmentForm")),
        VerifyIdentityFileForm: defineAsyncComponent(() => import(".././verify-identity-file/VerifyIdentityFileForm.vue"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false }
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 }, pdpa: `${process.env.VUE_APP_PUBLIC_PATH}/pdpa` });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        return {
            props,
            createRulesTab1,
            data,
            refs,
            isLoading,
            router,
            onClickOpenModalOtp,
            onNextRegister,
            onPrevRegister
        };
    }
});
</script>

<style scoped>
.bg-account {
    background-image: url("../../../assets/bg/bg-account.jpg");
    background-size: 100% 100%;
}
</style>
